import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FAQS } from "@/components/site/data";

export default function Faq() {
  return (
    <section id="faq" className="bg-base py-24 md:py-36" data-testid="faq">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="overline mb-5">Good to Know</p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#f5f5f0] tracking-tight leading-tight">
            Questions,<br /><span className="italic text-[#c6a87c]">answered</span>
          </h2>
          <p className="text-zinc-500 mt-6 max-w-xs">
            Still unsure? Reach out and I&apos;ll happily walk you through anything.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7 lg:col-start-6"
        >
          <Accordion type="single" collapsible className="w-full" defaultValue="item-0">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-[#f5f5f0] hover:text-[#c6a87c] hover:no-underline text-lg md:text-xl font-serif py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
